<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <v-row>
      <v-col>
        <VTextField
          v-model="data.name[selectedLang]"
          :label="$t('forms.labels.name')"
          :rules="{ required: selectedLang === teamMainLang , min: 1, max: 200 }"
          data-cy="categoryForm-name"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';

/**
 * Used by:
 *  - Maintenance Schedule
 *  - Automatic Sentence
 */
export default {

    components: {
        ValidationObserver,
        SlotScopeWatcher,
        VTextField,
    },
    props: {
        category: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: { name: {} },
        };
    },
    computed: {
        ...mapGetters([
            'teamMainLang',
            'selectedLang',
        ]),

    },
    async created() {
        if (this.isEdition) {
            this.data = this.category;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
